module.exports = __webpack_public_path__ + "img/martina.dd33103f.jpg";